import { Observable } from 'rxjs';

export enum ReloginAction {
  ForceRelogin = 'force_relogin'
}

export function openReloginWindow(options: { action?: ReloginAction; } = {}): Window | null {
  const url = new URL(`${window.location.origin}/relogin?redirect_url=window_close`);

  if (options.action) {
    url.searchParams.set('action', options.action);
  }

  const size = 800;
  const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
  const wTop = window.screenTop ? window.screenTop : window.screenY;
  const left = wLeft + (window.innerWidth / 2) - (size / 2);
  const top = wTop + (window.innerHeight / 2) - (size / 2);

  const newWindow = window.open(
    url.toString(),
    'Coevera CRM Login',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, height=${size},width=${size},left=${left},top=${top}`
  );
  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }
  return newWindow;
}

export function reloginInPopup(options: { action?: ReloginAction; } = {}): Observable<void> {
  return new Observable<void>(subscriber => {
    const newLoginWindow = openReloginWindow(options);
    if (!newLoginWindow) {
      subscriber.complete();
      return;
    }

    const messageCallback = (event: MessageEvent) => {
      const data = event.data as { type?: string; result?: 'success' | 'failed'; } | null;
      if (data && data.type === 'pipeliner-auth' && data.result === 'success') {
        subscriber.next();
        subscriber.complete();
      }
    };
    window.addEventListener('message', messageCallback);

    const watcher = setInterval(() => {
      if (newLoginWindow.closed) {
        subscriber.complete();
      }
    }, 500);

    return () => {
      window.removeEventListener('message', messageCallback);
      clearInterval(watcher);
    };
  });
}
